import React from 'react';

const src = 'https://instagram-brand.com/wp-content/themes/ig-branding/assets/images/ig-logo-email.png';

export function InstagramLogo(props) {
  return (
    <img className={ `instagram-logo ${ props.className ? props.className : '' }` } src={ src }  alt="instagram" />
  )
}